module.exports = __webpack_public_path__ + "static/media/dieet-club-facebook-cover.e09447aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dieet-club-facebook-cover.jpg
// module id = 8
// module chunks = 0